<div class="overflow">
    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="position-rela.tive w-100">
                <div class="d-flex align-items-center w-100" style="height: 52% !important;">

                    <img src="../../../assets/images/banners/operation-banner.png"
                        class="img img-responsive w-100 h-100 d-none d-md-block" width="100%"
                        alt="application banner" />

                    <img src="../../../assets/images/banners/operation-mobile.png"
                        class="img img-responsive d-block d-md-none" width="100%" alt="mobileapplication banner" />

                    <div class="position-absolute w-100 home-banner">
                        <div class="row h-100 w-100">
                            <div class="col-8 col-md-4 col-sm-6 banner-section">
                                <div class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content"
                                    role="heading" aria-level="1">
                                    <span>Operations and Maintenance</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                    <span>We triage potential issues and are expedient in resolving them with optimal
                                        support.</span>
                                </div>
                                <div class="col pt-lg-3 pt-4 mt-lg-3">

                                    <a href="contact" class="global_button   text-left col text-white white_button"
                                        role="button" tabindex="0" aria-label="View Contact Page">
                                        <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                                alt="Contact - operations and maintenance" /></div>
                                        CONTACT US
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="laptop_bg_image">
        <div class="container-fluid pt-5">
            <div class="row">
                <div class=" col-lg-6 col-12">
                    <div class="mobile_service_images m-5">
                        <img src="../../../assets/images/application/application-bulidimage.png"
                            class="img img-responsive" alt="bulidimage" />
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="application_content_service global_section_header pt-5">
                        Proactive maintenance to ensure to make your software robust and secure.
                    </div>
                    <div class="application_service-subcontent global_section_content pt-5">
                        <p>Information technology is key business enabler to support business growth for any sized
                            company or for a government agency. The operations and maintenance need to be done in
                            real time to be up to date and make sure there are no issues. As, the environment
                            changes dynamically with upgrades and expansions, we ensure you to focus on your key
                            business requirements while we manage your day to day IT operations with our solutions.
                        </p>
                        <p class="global_section_content2">Operations include administration and management of essential
                            elements to effectively,
                            efficiently, and proactively utilize technology, information, and data.</p>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="feature-icon-wrapper section-space-1--ptb_100">
        <div class="container-fluid">

            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-wrap text-center section-space--mb_40">
                        <div class="section-sub-title mb-20 sixthheading" role="heading" aria-level="1">Software
                            Maintenance And Support Services</div>
                        <p class="software-text">Get preventive maintenance and on-demand support for all your
                            applications with our software maintenance and support solutions.
                        </p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="feature-list__two">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 wow move-up">
                                <div class="ht-box-icon style-02 single-svg-icon-box">
                                    <div class="icon-box-wrap">
                                        <div class="icon">
                                            <img src="../../../assets/images/operation-images/maintainence.png"
                                                alt="maintainance of IT" />
                                        </div>
                                        <div class="content">
                                            <div class="software-heading fifthheading">Maintenance of IT infrastructure

                                            </div>
                                            <div class="software-text mt-3">
                                                Key to business continuity, a process that is needed to sustain a
                                                business throughout its operational life cycle. The maintenance is
                                                vital as it consists of all the elements that support the operations
                                                and usability of data.

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 wow move-up">
                                <div class="ht-box-icon style-02 single-svg-icon-box">
                                    <div class="icon-box-wrap">
                                        <div class="icon">
                                            <img src="../../../assets/images/operation-images/administration.png"
                                                alt="administration" />
                                        </div>
                                        <div class="content">
                                            <div class="software-heading fifthheading">Administration</div>
                                            <div class="software-text mt-3"> We provide single source for all the
                                                software
                                                applications in the portfolio. Our team know
                                                s where to look and what to do and can integrate separate
                                                applications into work flows and make sure software
                                                works as promised.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 wow move-up">
                                <div class="ht-box-icon style-02 single-svg-icon-box">
                                    <!-- ht-box-icon Start -->
                                    <div class="icon-box-wrap">
                                        <div class="icon">
                                            <img src="../../../assets/images/operation-images/trouble-shooting.png"
                                                alt="trouble-shooting" />
                                        </div>
                                        <div class="content">
                                            <div class="software-heading fifthheading">Troubleshooting</div>
                                            <div class="software-text mt-3">We do technical diagnosis on the issue
                                                and
                                                logical
                                                search on the source of the issue. We perform the following process
                                                to resolve the issue. We Identify the issue, Analyze the cause and
                                                Correct the issue.
                                                and recheck whether the issue is resolved with regular follow ups.
                                            </div>

                                        </div>
                                    </div>
                                    <!-- ht-box-icon End -->
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 wow move-up">
                                <div class="ht-box-icon style-02 single-svg-icon-box">
                                    <!-- ht-box-icon Start -->
                                    <div class="icon-box-wrap">
                                        <div class="icon">
                                            <img src="../../../assets/images/operation-images/configuration.png"
                                                alt="configuration" />
                                        </div>
                                        <div class="content">
                                            <div class="software-heading fifthheading">Configuration Management</div>
                                            <div class="software-text mt-3">This is used to have an understanding of
                                                the
                                                status of
                                                complex assets and ensure the serviceability at the lowest cost.
                                                Configuration management involves high degree of automation to
                                                achieve goals. With this it is easier to build in checks and
                                                redundancies, improving the potential for errors due to human error
                                                and the exactness for keeping assets in the desired state. </div>

                                        </div>
                                    </div>
                                    <!-- ht-box-icon End -->
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 wow move-up">
                                <div class="ht-box-icon style-02 single-svg-icon-box">
                                    <!-- ht-box-icon Start -->
                                    <div class="icon-box-wrap">
                                        <div class="icon">
                                            <img src="../../../assets/images/operation-images/server.png"
                                                alt="server" />
                                        </div>
                                        <div class="content">
                                            <div class="software-heading fifthheading">Server repair management</div>
                                            <div class="software-text mt-3">We help monitor the server and apps
                                                running
                                                on the
                                                server. We ensure service and repair processing with improved
                                                product visibility across the system and timely checks of status,
                                                uptime, and monitoring of any new or recurring issues. Our team will
                                                examine servers and find ways to optimize performance and ensure
                                                business success.
                                            </div>

                                        </div>
                                    </div>
                                    <!-- ht-box-icon End -->
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 wow move-up">
                                <div class="ht-box-icon style-02 single-svg-icon-box">
                                    <!-- ht-box-icon Start -->
                                    <div class="icon-box-wrap">
                                        <div class="icon">
                                            <img src="../../../assets/images/operation-images/remote.png"
                                                alt="Remote IT Support" />
                                        </div>
                                        <div class="content">
                                            <div class="software-heading fifthheading">Remote IT Support Services</div>
                                            <div class="software-text mt-3">Get timely technical support to
                                                troubleshoot
                                                crucial,
                                                mission-critical issues on time every time with our remote IT
                                                support services. With a global team of skilled resources, we are
                                                equipped to serve you round-the-clock.
                                            </div>

                                        </div>
                                    </div>
                                    <!-- ht-box-icon End -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!--======= Insights section Start =======-->
    <div class="layouts-section-wrap">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 offset-sm-2 col-sm-8">
                    <div class="pt-md-5" data-aos="fade-up">
                        <div class="insight-title global_section_header" role="heading" aria-level="1">
                            Insights
                            <!-- <a href=""></a> -->
                        </div>
                        <div class="insight-subtitle  vision-content-section mt-3">
                            <span>
                                Explore insights and inspiration to unlock innovation, build trust, and engineer
                                advantage
                                for your digital journey.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">

            <div class="-row d-lg-none pt-lg-4">
                <div class="px-4 -col-lg-12">
                    <div class="flexible-image-slider-wrap">

                        <swiper-container class="single-flexible__container " slides-per-view="1" autoplay="false"
                            loop="true" navigation="true" pagination="true">

                            <swiper-slide>
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider1.png"
                                        class="img img-responsive w-100 h-100" alt="Marketing Personalization" />
                                    <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header1 px-0" role="heading"
                                            aria-level="1">
                                            <span>The Future of Marketing Personalization: AI-Powered Journeys</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content1 px-0 pt-lg-1">
                                            <div>Across the entire customer journey, AI is assisting marketers in
                                                providing more helpful, enjoyable experiences for shoppers and improving
                                                performance. Find how retail stores can capitalize on this technology
                                                trend.</div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="personalize-and-machine-learning" class="global_button"
                                                role="button" tabindex="0" aria-label="Read Personalize ML">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="arrowblack img for read" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>

                            <swiper-slide>
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider2.png"
                                        class="img img-responsive w-100 h-100"
                                        alt="Embracing the next era of Digital" />
                                    <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header1 px-0">
                                            <span>Embracing the next era of Digital: From Survival, Thriving to
                                                Reinvigorating</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content1 px-0 pt-lg-">
                                            <div>Learn how businesses have progressed into the digital post-pandemic era
                                                and how far they can go to adapt to the changing customer mindset.</div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="/postpandamic" class="global_button"
                                                aria-label="Read Postpandamic Insights" role="button" tabindex="0">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="Read All Insights - PostPandamic" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>

                            <swiper-slide>
                                <div class="single-flexible-slider">
                                    <img src="../../../assets/images/homepage/insights/slider3.png"
                                        class="img img-responsive w-100 h-100" alt="Drive digital adoption" />
                                    <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                                        <div class="insight-content global_section_header1 px-0">
                                            <span>Drive digital adoption. Every minute. Every hour. Every day</span>
                                        </div>
                                        <div class="insight-subcontent global_section_content1 px-0 pt-lg-1">
                                            <div>Increase software adoption and knowledge retention while making a
                                                positive impact on the working lives of your employees.</div>
                                        </div>
                                        <div class="insight-button text-center py-3 py-md-5">
                                            <a href="migrate-cloud" class="global_button"
                                                aria-label="Read migrate cloud Insights" role="button" tabindex="0">
                                                <div class="dub-arrow"><img
                                                        src="../../../assets/images/button/arrowBlack.png"
                                                        alt="Read All Insights - cloud" /></div>READ ALL INSIGHTS
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>

                        </swiper-container>

                    </div>
                </div>
            </div>

            <div>
                <app-insightsslider></app-insightsslider>
            </div>

        </div>
    </div>
    <!--======= Insights section Ends =======-->